<template>
  <b-col md="6">
    <form-group :validations="validation">
      <div slot-scope="{ errors, invalid }">
        <b-alert show class="overflow_div">
          <b-form-group :class="{ invalid }">
            <label
              >{{ label }}
              <b-icon
                icon="arrow-clockwise"
                class="d-inline"
                @click="refreshCategories"
              ></b-icon>
            </label>
            <category
              :remove-category="removeCategory"
              :selected-category="selectedCheckBoxes"
              :margin="0"
              v-for="category in CheckBoxItems"
              :key="category.id"
              :category="category"
            />
          </b-form-group>
        </b-alert>
        <form-errors-manager :errors="errors" />
      </div>
    </form-group>
  </b-col>
</template>
<script>
import FormGroup from "../../../validator/FormGroup.vue";
import FormErrorsManager from "../../../validator/FormErrorsManager.vue";
import category from "../../product/category.vue";
export default {
  name: "CheckBoxManager",
  components: { FormGroup, FormErrorsManager, category },
  props: ["validation", "CheckBoxItems", "selectedCheckBoxes", "label"],
  data() {
    return {
      selected: this.selectedCheckBoxes,
    };
  },
  methods: {
    refreshCategories() {
      this.$store.dispatch("Category/getCategories");
    },
    removeCategory(category) {
      this.selected.splice(this.selected.indexOf(category), 1);
    },
  },
};
</script>
<style scoped>
.overflow_div {
  width: auto;
  height: 300px !important;
  overflow-y: auto;
}
</style>